export const PERFECT_STORE_PREVIEW_TABS = {
  REQUIREMENTS: 0,
  UPDATE_STORE_VISITS: 1
};
